import { AudioPlayerWithSeekbarHandler } from './audioplayerwithseekbarhandler';
import { AudioPlayer } from '../audioplayerImpl';

export interface AudioPlayerWithSeekbar {
    setSeekbar(seekBar: HTMLInputElement): void;
    changeCurrentTime(): void;
    onReset(): void;
    unregisterAudioEvents(): void;
    setAudioPlayerWithSeekBarHandler(audioPlayerWithSeekbarHandler: AudioPlayerWithSeekbarHandler): void;
}

export class AudioPlayerWithSeekbarImpl implements AudioPlayerWithSeekbar {
   
    private audioPlayerWithSeekbarHandler: AudioPlayerWithSeekbarHandler;
    private seekBar: HTMLInputElement;
    private audio: HTMLMediaElement;

    constructor(audioPlayer: AudioPlayer) {
        this.updateTheTime = this.updateTheTime.bind(this);
        this.setSeekBar = this.setSeekBar.bind(this);
        this.changeCurrentTime = this.changeCurrentTime.bind(this);

        this.audio = audioPlayer.getAudio();

        this.audio.addEventListener('timeupdate', this.updateTheTime, false);
        this.audio.addEventListener('durationchange', this.setSeekBar, false);

        // this.audio.remov
    }

    setAudioPlayerWithSeekBarHandler(audioPlayerWithSeekbarHandler: AudioPlayerWithSeekbarHandler): void {
        this.audioPlayerWithSeekbarHandler = audioPlayerWithSeekbarHandler;
    }

    unregisterAudioEvents() {
        console.log("-----unregisterAudioEvents() invoked");
        this.audio.removeEventListener('timeupdate', this.updateTheTime, false);
        this.audio.removeEventListener('durationchange', this.setSeekBar, false);
        this.audioPlayerWithSeekbarHandler.updateEndTime("00:00");
        //this.audio.duration = NaN;
        this.audio.currentTime = 0;
    }

    onReset() {

        console.log("-----onReset()1 invoked" + this.audio.duration);
        console.log("-----onReset()2 invoked" + this.audio.currentTime);

        this.audioPlayerWithSeekbarHandler.updateSeekbarPlayedPartColor("0");
        this.audioPlayerWithSeekbarHandler.updateStartTime("00:00");
        this.audioPlayerWithSeekbarHandler.updateEndTime(this.audio.currentTime > 0
            ? this.getTimingsWithTwoDigits(this.audio.duration) : "00:00");
        if (this.audio.duration === this.audio.currentTime) {
            this.audioPlayerWithSeekbarHandler.updateEndTime("00:00");
        }

        /*  this.audioPlayerWithSeekbarHandler.updateEndTime(Number.isNaN(this.audio.duration) ? "00:00" :
             this.getTimingsWithTwoDigits(this.audio.duration)); */
        this.seekBar.min = "0";
        this.seekBar.max = "0";
    }

    onComplete(): void {
        this.audioPlayerWithSeekbarHandler.updateStartTime("00:00");
    }

    onError(): void {
        this.onReset();
    }

    setSeekbar(seekBar: HTMLInputElement) {
        this.seekBar = seekBar;
    }

    changeCurrentTime() {
        this.audio.currentTime = +this.seekBar.value;
    }

    setSeekBar() {
        this.seekBar.min = "0";
        this.seekBar.max = String(this.audio.duration);
    }

    updateTheTime() {
        let currentPercentage = (this.audio.currentTime / this.audio.duration) * 100;
        this.audioPlayerWithSeekbarHandler.updateSeekbarPlayedPartColor(String(Math.floor(currentPercentage)));

        this.audioPlayerWithSeekbarHandler.updateEndTime(this.audio.currentTime > 0 ? this.getTimingsWithTwoDigits(this.audio.duration) : "00:00");
        this.audioPlayerWithSeekbarHandler.updateStartTime(this.getTimingsWithTwoDigits(this.audio.currentTime));

        if (this.seekBar !== null) {
            this.seekBar.min = "0";
            this.seekBar.max = String(this.audio.duration);
            this.seekBar.value = String(this.audio.currentTime);
        }
    }

    getTimingsWithTwoDigits(timeToConvert: number): string {
        let dateObj = new Date(timeToConvert * 1000);
        let minutes = dateObj.getUTCMinutes();
        let seconds = dateObj.getSeconds();
        let twoDigitsTiming = minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
        return twoDigitsTiming;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/player/playerwithseekbar/audioplayerwithseekbarImpl.ts